import React from 'react';
import { Form, Card, Input, Button, message, Select, Alert } from 'antd';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/client';
// import { QuestionCircleOutlined } from '@ant-design/icons';
import PageTitle from '../../../components/PageTitle';
import ProgressModal from '../../../components/ProgressModal';
import { ORDER_COUNTRIES } from '../../../utils/constants';
import { Order } from '../../../utils/types';

const UPDATE_ORDER_MUTATION = gql`
  mutation UpdateOrderMutation($order: OrderInput!, $id: ID!) {
    updateOrder(order: $order, id: $id) {
      id
    }
  }
`;

type UpdateOrderAddressState = {
  order: Order,
  edit: boolean,
};

type FormType = {
  recipientName: string,
  phone: string,
  country: string,
  address: string,
  city: string,
  state: string,
  zipCode: string,
  notes: string,
};

function UpdateOrderAddress() {
  const { id } = useParams<{ id: string }>();
  const location = useLocation<UpdateOrderAddressState>();
  const order = location?.state?.order;
  const edit = location?.state?.edit;
  const formInitData = { ...order };
  const onFinish = (values: FormType) => {
    console.log('Success:', values);
    ProgressModal.show();
    updateOrder({ variables: { order: values, id } });
  };
  const [form] = Form.useForm<FormType>();

  const [updateOrder] = useMutation(UPDATE_ORDER_MUTATION, {
    onError: () => null,
    onCompleted: data => {
      console.log(data);
      ProgressModal.hide();
      if (edit) {
        message.success('地址已修改，谨慎起见请通知客服');
      } else {
        message.success('地址已提交');
      }
      history.replace('/orders');
    },
  });

  const history = useHistory();

  return (
    <div className="UpdateOrderAddress">
      <PageTitle>{edit ? '修改' : '提交'}收货地址</PageTitle>
      <Card bordered={false}>
        <Alert type="warning" message="请用目的国家的语言填写" />
        <Form form={form} onFinish={onFinish} initialValues={formInitData}>
          <Form.Item
            label="收件人名字"
            name="recipientName"
            rules={[{ required: true, message: '必填' }]}
          >
            <Input allowClear />
          </Form.Item>
          <Form.Item label="联系电话" name="phone" rules={[{ required: true, message: '必填' }]}>
            <Input allowClear />
          </Form.Item>
          <Form.Item label="目的国家" name="country" rules={[{ required: true, message: '必填' }]}>
            <Select>
              {Object.entries(ORDER_COUNTRIES).map(([countryCode, countryName]) => (
                <Select.Option value={countryCode} key={countryCode}>
                  {countryName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="街道地址" name="address" rules={[{ required: true, message: '必填' }]}>
            <Input allowClear />
          </Form.Item>

          <Form.Item label="城市" name="city" rules={[{ required: true, message: '必填' }]}>
            <Input allowClear />
          </Form.Item>

          <Form.Item label="州/省" name="state" rules={[{ required: true, message: '必填' }]}>
            <Input allowClear />
          </Form.Item>

          <Form.Item
            label="邮编"
            name="zipCode"
            rules={[
              { required: true, message: '必填' },
              // { type: 'string', pattern: /^[0-9]+$/, len: 5, message: '邮编不合法'},
            ]}
          >
            <Input allowClear />
          </Form.Item>

          {/* <Form.Item
            label="备注"
            name="notes"
            // rules={[{ }]}
          >
            <Input.TextArea allowClear />
          </Form.Item> */}

          <Form.Item>
            <Button block type="primary" htmlType="submit">
              提交地址
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

export default UpdateOrderAddress;
